import VBtn from './VBtn'

/* istanbul ignore next */
VBtn.install = function install (Vue) {
  Vue.component(VBtn.name, VBtn)
}

export default VBtn



// WEBPACK FOOTER //
// ./src/components/VBtn/index.js